import React from 'react';

import { CARD_THEMES } from './card_theme';
import { IndexCard, getIndexCards } from './index_card';
import { LinkCard, getCardPaths } from './link_card';

import type { Contact } from 'bundles/backoffice/contacts/types';
import type { ContactToolCall } from '../types';

interface ContactCardsProps {
  toolCalls: ContactToolCall[];
}

export function ContactCards({ toolCalls }: ContactCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls, 'path').map(path => (
        <LinkCard key={path} path={path} theme={CARD_THEMES.contact}>
          {(contact: Contact) => {
            const details = [contact.jobTitle, contact.businessName].filter(Boolean).join(' • ');

            return (
              <>
                <div className="fw-semibold text-truncate">{contact.label}</div>
                {details && <div className="small text-muted text-truncate">{details}</div>}
              </>
            );
          }}
        </LinkCard>
      ))}
      {getIndexCards(toolCalls).map(index => (
        <IndexCard index={index} key={index.path} label="contacts" pageName="Contacts" theme={CARD_THEMES.contact} />
      ))}
    </>
  );
}
